__webpack_require__.p = "/wp-content/uploads/ultra-app/";